import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import {
  VIEW_DETAILS_COMMON_KEYS,
  VIEW_BENEFICIARY_DETAILS_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function BeneficiaryDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <Row xs={12}>
      <Col xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.ACCOUNT_NO)}</label>
        <span>{option?.beneAccNo || '-'}</span>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BENEFICIARY_NAME)}</label>
        <span>{option?.beneName || '-'}</span>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BRANCH)}</label>
        <span>{option?.beneBrn || '-'}</span>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BENEFICIARY_TYPE)}</label>
        <span>
          {option?.beneType === 'THIRD_PARTY' ||
          option?.beneType === 'DDACC' ||
          option?.beneType === 'RTGS' ? (
            <Row xs={'12'}>
              <Col xs={'12'} sm={'12'} md={'12'}>
                {option?.beneType || '-'}
              </Col>
              <Col xs={'12'} sm={'12'} md={'12'}>
                <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BIC_CODE)}</label>
                <span>{option?.bicCode || '-'}</span>
              </Col>
              <Col xs={'12'} sm={'12'} md={'12'}>
                <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.SORT_CODE)}</label>
                <span>{option?.sortCode || '-'}</span>
              </Col>
              <Row xs={'12'}>
                <Col xs={'12'} sm={'12'} md={'12'} style={{ marginLeft: '16px' }}>
                  <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BANK_NAME)}</label>
                  <span>{option?.bankName || '-'}</span>
                </Col>
                <Col xs={'12'} sm={'12'} md={'12'} style={{ marginLeft: '16px' }}>
                  <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BANK_ADDRESS)}</label>
                  <span>{option?.bankAddress || '-'}</span>
                </Col>
              </Row>
            </Row>
          ) : (
            <span>{option?.beneType || '-'}</span>
          )}
        </span>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.NICK_NAME)}</label>
        <span>{option?.shortName || '-'}</span>
        {option?.beneType === 'INBK' || option?.beneType === 'IAT' ? (
          <>
            <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.BENEFICIARY_CURRENCY)}</label>
            <span>{option?.beneCurrency || '-'}</span>
          </>
        ) : null}
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.TRANSFER_LIMIT)}</label>
        <span>
          {' '}
          <NumberFormat
            value={option?.maxTransferLimit}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </span>
      </Col>

      <Col xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.VISIBLE_TO_GROUP)}</label>
        <span>{option?.isVisibleToGroup === 'Y' ? 'Yes' : 'No'}</span>
        <label>{t(VIEW_BENEFICIARY_DETAILS_KEYS.OPERATION_TYPE)}</label>
        <span>
          {option?.operationType === 'A'
            ? 'Add Beneficiary'
            : option?.operationType === 'M'
            ? 'Modify Beneficiary'
            : 'Delete Beneficiary'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
